
import ReactDOM from 'react-dom/client';
import './index.css'
//import Box3d from "./components/Box3d.tsx";
import Configurator from "./components/Configurator.tsx";

document.addEventListener('DOMContentLoaded', () => {
    /*const divBoxViewer = document.getElementById('boxViewer');*/
    const divConfigurator = document.getElementById('configurator-eventeam');

   /* if (divBoxViewer) {
        ReactDOM.createRoot(divBoxViewer).render(<Box3d />);//<BoxViewer />);
    }*/

    if (divConfigurator) {
        ReactDOM.createRoot(divConfigurator).render(<Configurator />);//<BoxViewer />);
    }

});


